export default __webpack_public_path__ + "img/bg-comments.b3189714.png";